import { IPaginatedResponse, IResponse } from "../../../model";
import ServiceBase from "../../../servicebase";
import { IProductoTipo } from "../model/IProductoTipo";

export default class ProductoTipoService extends ServiceBase {
  all = () : Promise<IResponse<IProductoTipo[]>> => 
    this.GetFetch<IResponse<IProductoTipo[]>>('entity/productotipo/all', {});

  get = (data:{ id?: number }) : Promise<IResponse<IProductoTipo>> => 
    this.GetFetch<IResponse<IProductoTipo>>('entity/productotipo', data);

  find = (data:{ pageIndex?: number, pageSize?: number, sort?: string,
       id?: number, nombre?: string, codigo?: string, activo?: boolean }) : Promise<IPaginatedResponse<IProductoTipo>> => 
    this.GetFetch<IPaginatedResponse<IProductoTipo>>('entity/productotipo/find', data);

  upsert = (data:IProductoTipo) : Promise<IResponse<IProductoTipo>> => 
    this.PostFetch<IResponse<IProductoTipo>>('entity/productotipo', data);

  delete = (data:{ id:number, undelete?: boolean}) : Promise<IResponse<void>> => 
    this.DeleteFetch<IResponse<void>>('entity/productotipo', data);

}
